import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { InputModel } from '../../models';
import { InputWithoutSource } from '../../componentTypes';
import { CustomInputNumberWrapper, InputControls } from '../../components';
import { CustomFormItem } from '../../../custom_shared/components';
import { FieldValidators } from '../../misc';


const CountOfReinstatementsInput: InputWithoutSource = ({ input }) => (
    <CustomFormItem
        name={input.guid}
        customValidator={(...args) => FieldValidators.numberValidator(...args, 1, 5)}
        isReadOnly={input.isReadOnly}
    >
        <CustomInputNumberWrapper input={input} label={input.name} topRightNode={<InputControls input={input} />} />
    </CustomFormItem>
);

CountOfReinstatementsInput.meta = {
    inputType: InputModel.name
};

export default observer(CountOfReinstatementsInput);
